import axios from 'axios';
import { API_URL } from '@/config';

export default {

  list() {
    return axios.get(`${API_URL}/vsphere/vms`);
  },

  listOs() {
    return axios.get(`${API_URL}/vsphere/os`);
  },

  total() {
    return axios.get(`${API_URL}/vsphere/total`);
  },

  action(data) {
    return axios.post(`${API_URL}/vsphere/action-vm`, data);
  },

  calculateVmPrice(vmConfig) {
    return axios.post(`${API_URL}/vsphere/calculate-vm-price`, vmConfig);
  },

  addVm(vm) {
    return axios.post(`${API_URL}/otrs/add-vm`, vm);
  },

  editVm(vm) {
    return axios.post(`${API_URL}/otrs/edit-vm`, vm);
  },

  partialUpdate(vm) {
    return axios.patch(`${API_URL}/otrs/edit-vm`, vm);
  },

  deleteVm(vm) {
    return axios.post(`${API_URL}/otrs/delete-vm`, vm);
  },

  export() {
    window.open(`${API_URL}/vsphere/export?extension=csv`, '_blank');
  },

};
